import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import React, { Component } from 'react';
import { Paper, Button, TextField, Typography } from '@material-ui/core';
import { executionByInvoiceId, checkInvoice } from '../../../redux/actions/tracker/executionActions';
import { workflowStepList } from '../../../redux/actions/tracker/workflowstepActions';
import StepMS from './../Check/MsStepper';
import PageBase from '../../../app/PageBase';

const styles = {
  textField: {
    marginTop: 20,
    marginBottom: 20,
    marginLeft: 20,
    marginRight: 20,
    width: 200,
  },
};

class CheckPage extends Component {

  constructor(props) {

    super(props);
    this.ChekIn = this.ChekIn.bind(this);

    this.state = {
      CodeBar: '',
      wfsteps: {},
      answers: [],
      lstExecution: {},
      objInvoice: {},
      qntdfields: 0,
    };

  }

  ChekIn(event) {

    const { user } = this.props;
    const { qntdfields, CodeBar, answers } = this.state;
    const payload = {
      codebar: CodeBar,
      companyid: user.context.idCompany,
      userid: user.IdUser,
      answers,
    };

    event.preventDefault();
    if (qntdfields === answers.length)
      checkInvoice(payload).then((response) => {

        if (response.return && response.return.invoiceId !== 0) {

          executionByInvoiceId(response.return.invoiceId)
            .then(lstExecution => workflowStepList(response.return.workflowId)
              .then(wfsteps => this.setState({ wfsteps, lstExecution })));

        } else {

          alert(response.message);
          this.props.history.push('/invoice/search');

        }

      }, (e) => {

        if (e !== null)
          alert(e.message);
        else
          alert('Bad Request');

      });
    else
      alert('preencha todos os campos');


  }

  handleChange = () => (event) => {

    this.setState({
      [event.target.name]: event.target.value,
    });

  };

  fieldHandleChange = () => (event) => {

    const { answers } = this.state;
    const name = event.target.name;
    const value = event.target.value;

    const currentIndex = answers.map(obj => obj.FieldName).indexOf(name);

    if (currentIndex === -1) {

      answers.push({ FieldName: name, answer: value });
      this.setState({ answers });

    } else {

      answers[currentIndex].answer = value;
      this.setState({ answers });

    }

  };

  onClose = (response) => {

    if (response.length !== this.state.qntdfields)
      this.setState({ qntdfields: response.length });

  }

  render() {

    const { lstExecution, wfsteps } = this.state;

    return (<div>

      <PageBase
        title={I18n.t('menu.workflowExecution')}
        showCreateButton={false}
        showEditButton={false}
        showDeleteButton={false}
      >
        <TextField
          id="CodeBar"
          name="CodeBar"
          label={I18n.t('fields.codeBar')}
          value={this.state.CodeBar}
          onChange={this.handleChange('CodeBar')}
          style={styles.textField}
        />
        <Button variant="contained" color="primary" onClick={this.ChekIn}>
          {I18n.t('button.search')}
        </Button>
        <br />
        <StepMS
          data={{ lstExecution, wfsteps }}
          onClick={this.ChekIn}
          onChange={this.fieldHandleChange}
          onClose={this.onClose}
          dynamic
        />


      </PageBase>
    </div>);

  }
}

export default CheckPage;



// WEBPACK FOOTER //
// ./src/components/tracker/Check/CheckPage.js